import React from 'react';
import { useTranslation } from 'react-i18next';
import { CustomerInfo } from '../../../../model/customerWithUpdates';
import { CustomerItemStatus } from '../../../../store/features/customerUpdates/customerUpdatesSlice';
import { useCustomerUpdatesDialogStyles } from './CustomerUpdatesDialog.styles';

export const CustomerInfoSection: React.FC<{
    customer: CustomerInfo;
    status?: CustomerItemStatus;
}> = ({ customer, status }) => {
    const styles = useCustomerUpdatesDialogStyles();
    const { t } = useTranslation();

    return (
        <div className={styles.dialogTitleCustomerSection}>
            <div className={styles.dialogTitleCustomerName}>
                {customer.firstName} {customer.lastName}{' '}
                {status && (
                    <span style={{ textTransform: 'none' }}>
                        {'('}
                        {t(`CustomerItemStatus_${status}`)}
                        {')'}
                    </span>
                )}
            </div>
            <div className={styles.dialogTitleCustomerInfo}>
                <span>
                    {`${t('CustomerDialog_Seat')}: `}
                    <b>{customer.seatNumber}</b>
                </span>
                {customer.cabin && (
                    <span>
                        {`${t('CustomerDialog_Cabin')}: `}
                        <b>{customer.cabin}</b>
                    </span>
                )}
                {customer.frequentFlyerTier && (
                    <span>
                        {`${t('CustomerDialog_Tier')}: `}
                        <b>{customer.frequentFlyerTier}</b>
                    </span>
                )}
                {customer.pnr && (
                    <span>
                        {`${t('CustomerDialog_Pnr')}: `}
                        <b>{customer.pnr}</b>
                    </span>
                )}
            </div>
        </div>
    );
};
